module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_item_message":{"none":"There are no reviews.","filtered":"No reviews match your current selections."}}}')
  delete Component.options._Ctor
}
